import React from "react";
import { Link } from "react-router-dom";
import { Globe, Pencil, Phone } from "lucide-react";

export function filterBots(bots, searchTerm) {
  const q = searchTerm.trim().toLowerCase();
  if (!q) return bots;
  return bots.filter((bot) => [bot.name, bot.domain, bot.owner_name, bot.industry, bot.business_type, bot.whatsapp_phone_number]
    .some((value) => typeof value === "string" && value.toLowerCase().includes(q)));
}

export default function BotCard({ bot, titleTo, editTo, onEdit, children }) {
  const name = bot.name || bot.id;
  return (
    <article className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm transition hover:border-slate-300 hover:shadow-md">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="truncate text-base font-bold text-slate-900">
            {titleTo ? <Link to={titleTo} className="hover:text-cyan-800 hover:underline">{name}</Link> : name}
          </h3>
          {bot.domain && <div className="mt-1 flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1 text-xs text-slate-500">
              <Globe size={13} /> {bot.domain}
            </span>
          </div>}
        </div>
        {editTo && <Link to={editTo} aria-label={`Edit bot ${name}`} title="Edit Bot"
          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-slate-400 transition hover:bg-blue-50 hover:text-[#096dea]">
          <Pencil size={16} />
        </Link>}
        {!editTo && onEdit && (
          <button
            type="button"
            onClick={onEdit}
            aria-label={`Edit bot ${name}`}
            title="Edit Bot"
            className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-slate-400 transition hover:bg-blue-50 hover:text-[#096dea]"
          >
            <Pencil size={16} />
          </button>
        )}
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3 border-y border-slate-100 py-4 text-sm">
        <div>
          <span className="block text-[11px] font-semibold uppercase tracking-wider text-slate-400">Industry</span>
          <span className="mt-1 block truncate font-medium text-slate-800">{bot.industry || "Corporate"}</span>
        </div>
        <div>
          <span className="block text-[11px] font-semibold uppercase tracking-wider text-slate-400">Type</span>
          <span className="mt-1 block truncate font-medium text-slate-800">{bot.business_type || "Business"}</span>
        </div>
        {bot.whatsapp_phone_number && <div>
          <span className="block text-[11px] font-semibold uppercase tracking-wider text-slate-400">WhatsApp</span>
          <span className="mt-1 inline-flex items-center gap-1 truncate font-medium text-emerald-700">
            <Phone size={13} /> {bot.whatsapp_phone_number}
          </span>
        </div>}
      </div>

      <div className="flex items-center justify-end gap-3 pt-4">
        {children}
      </div>
    </article>
  );
}
